var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpiryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17424_38307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2019 6.03258C12.1937 6.985 11.9772 7.92408 11.5677 8.784M6.63051 11.604C5.89886 11.604 5.17437 11.4599 4.49842 11.1799C3.82246 10.8999 3.20827 10.4895 2.69092 9.97217C1.64607 8.92732 1.05908 7.51021 1.05908 6.03258M8.3448 7.74686L6.63051 5.604H4.05908",
    stroke: "#EB2726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9162 11.1754C11.6263 11.1754 12.2019 10.5998 12.2019 9.88972C12.2019 9.17964 11.6263 8.604 10.9162 8.604C10.2061 8.604 9.63049 9.17964 9.63049 9.88972C9.63049 10.5998 10.2061 11.1754 10.9162 11.1754Z",
    stroke: "#EB2726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41907 3.97529C1.60587 3.50845 1.85686 3.06994 2.16478 2.67243M3.81907 1.19814C4.30212 0.919217 4.82547 0.716816 5.3705 0.598145M11.8419 3.97529C11.6551 3.50845 11.4041 3.06994 11.0962 2.67243M9.44192 1.19814C8.95887 0.919217 8.43552 0.716816 7.8905 0.598145",
    stroke: "#EB2726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17424_38307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.630493 0.101074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiryIcon);
export default __webpack_public_path__ + "static/media/expiry-icon.66341003875b847bae4c68796b93408d.svg";
export { ForwardRef as ReactComponent };